var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(request,r){return _c('request-detail-card',{key:`${request.id}${r}`,attrs:{"medical-record-id":_vm.id,"request":request,"kind":"hospitalization","can-sign":_vm.canSign}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }